window.addEventListener('DOMContentLoaded', function() {
    let feature_posts_slider = document.querySelectorAll('.js-portfolio.splide');

    if(feature_posts_slider.length > 0){
        for(let i = 0; i < feature_posts_slider.length; i++){
            let splide = new Splide(feature_posts_slider[i], {
                type : 'loop',
                perPage: 2,
                rewind : true,
                gap: 12,
                arrows: true,
                pagination: false,
                drag: 'free',
                snap: true,
                breakpoints: {
                    640: {
                        fixedWidth: '80%',
                    }
                }
            });
            let bar = feature_posts_slider[i].querySelector( '.splide__progress-bar' );

            // Updates the bar width whenever the carousel moves:
            splide.on( 'mounted move dragged', function () {
                let end  = splide.Components.Controller.getEnd() + 1;
                let rate = Math.min( ( splide.index + 1 ) / end, 1 );

                bar.style.width = String( 100 * rate ) + '%';
            });

            splide.mount();
        }
    }
});
